import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=0b6af0b4&scoped=true"
import script from "./dates.vue?vue&type=script&lang=js"
export * from "./dates.vue?vue&type=script&lang=js"
import style0 from "./dates.vue?vue&type=style&index=0&id=0b6af0b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6af0b4",
  null
  
)

export default component.exports